import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { registerServiceWorker } from "./lib/serviceWorker";
import { UpdateNotification } from "./components/UpdateNotification";
import { Toaster } from "sonner";
import { initFxTier } from "./lib/fx/fxTier";

// Registra o Service Worker para PWA
registerServiceWorker();

// Orçamento de efeitos da UI (data-fx / data-motion no <html>).
// Antes do render para que a primeira pintura já saia no tier certo.
initFxTier();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
    <Toaster position="top-center" richColors closeButton />
    <UpdateNotification />
  </ErrorBoundary>
);
